import BaseStore from './BaseStore'

export class StorageStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'storages'
  }
}

export default new StorageStore()


// WEBPACK FOOTER //
// ./src/stores/StorageStore.js